export const measurementPeriodicityTypes = [
  { label: "Mensual", value: "MONTHLY" },
  { label: "Trimestral", value: "TRIMESTRAL" },
  { label: "Semestral", value: "BIANUAL" },
  { label: "Anual", value: "ANNUAL" }
]
